import {
  Box,
  Divider,
  Header,
  HeaderActionArea,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Popover,
  PopoverButton,
  PopoverContent,
  Typography,
} from "@deere/fuel-react";
import { AccountCircleOutlined, ExitToAppOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";
import { withOktaAuth } from "@okta/okta-react";
import React, { useState, useEffect, useCallback } from "react";
import { getDataWAuth } from "../utils/api-service";
import { USER_PREFERENCE } from "../constants/constant";
import UserProfileTable from "./UserProfileTable";
import { checkErrorMsg } from "../utils/utils";
import ToastMessageFunction from "./toast-message-function";

const AppHeader = (props) => {
  const [userName, setUserName] = useState("");
  const [userPreference, setUserPreference] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const toastManager = ToastMessageFunction();

  useEffect(() => {
    setUserName(props.authState.idToken.claims.name);
  }, [props.authState]);

  const logout = async () => {
    await props.oktaAuth.signOut();
  };

  const handleClick = async (event) => {
    setAnchorEl(event.currentTarget);

    try {
      const response = await getDataWAuth(USER_PREFERENCE);
      if (
         response.status === 200 &&
         response?.data?.data?.userProfile &&
         Object.keys(response?.data?.data?.userProfile).length > 0
      ) {
        setUserPreference(response.data.data);
      }
      else {
        showToast((response.response.data.message), "error");
      }
    } catch (error) {
      if (checkErrorMsg(error)) showToast(checkErrorMsg(error), "error");
      else
      showToast("RBAC Issue,Roles and Country Not Assigned Properly", "error");
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const showToast = useCallback(
    (message, severity) => {
      toastManager.getToast(message, severity);
    },
    [toastManager]
  );

  return (
    <Header title="Financial Solutions">
      {toastManager.toast}
      <HeaderActionArea>
        <Popover>
          <PopoverButton aria-label={"Account"} component={Button}>
            <AccountCircleOutlined sx={{ color: "gray" }} />
            <Typography
              sx={{ color: "gray", fontWeight: "bold", size: "small" }}
            >
              {userName}
            </Typography>
          </PopoverButton>

          <PopoverContent>
            <Box minWidth={"160px"}>
              <Box>
                <Divider />
                <ListItemButton
                  sx={{ pl: 5, backgroundColor: "white" }}
                  onClick={handleClick}
                >
                  <ListItemText
                    primary={"Switch User Profile"}
                    primaryTypographyProps={{
                      fontSize: "14px",
                      fontWeight: 600,
                      color: "#333",
                    }}
                  />
                </ListItemButton>
                <Popover
                  open={Boolean(anchorEl)}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                >
                  <Box sx={{ p: 2 }}>
                    {userPreference && (
                      <UserProfileTable
                        userPreference={userPreference}
                        onRefresh={handleClick}
                        onClose={handleClose}
                      />
                    )}
                  </Box>
                </Popover>
              </Box>

              <Box>
                <Divider />
                <ListItemButton
                  sx={{ pl: 5, backgroundColor: "white" }}
                  onClick={logout}
                >
                  <ListItemIcon>
                    <ExitToAppOutlined />
                  </ListItemIcon>
                  <ListItemText
                    primary={"Sign Out"}
                    primaryTypographyProps={{
                      fontSize: "14px",
                      fontWeight: 600,
                      color: "#333",
                    }}
                  />
                </ListItemButton>
              </Box>
            </Box>
          </PopoverContent>
        </Popover>
      </HeaderActionArea>
    </Header>
  );
};

export default withOktaAuth(AppHeader);